/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeatureFlagEntry } from './FeatureFlagEntry';
import { FeatureFlagEntryFromJSON, FeatureFlagEntryFromJSONTyped, FeatureFlagEntryToJSON } from './FeatureFlagEntry';

/**
 *
 * @export
 * @interface FeatureFlagPayload
 */
export interface FeatureFlagPayload {
  /**
   *
   * @type {{ [key: string]: FeatureFlagEntry; }}
   * @memberof FeatureFlagPayload
   */
  flags: { [key: string]: FeatureFlagEntry };
}

/**
 * Check if a given object implements the FeatureFlagPayload interface.
 */
export function instanceOfFeatureFlagPayload(value: object): value is FeatureFlagPayload {
  if (!('flags' in value) || value['flags'] === undefined) return false;
  return true;
}

export function FeatureFlagPayloadFromJSON(json: any): FeatureFlagPayload {
  return FeatureFlagPayloadFromJSONTyped(json, false);
}

export function FeatureFlagPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureFlagPayload {
  if (json == null) {
    return json;
  }
  return {
    flags: mapValues(json['flags'], FeatureFlagEntryFromJSON),
  };
}

export function FeatureFlagPayloadToJSON(value?: FeatureFlagPayload | null): any {
  if (value == null) {
    return value;
  }
  return {
    flags: mapValues(value['flags'], FeatureFlagEntryToJSON),
  };
}
